import useProductsMenu from './useProductsMenu';

export default useProductsMenu;
